import React from 'react';
import { FileText, Users, Target, Zap } from 'lucide-react';

const TechnologyBenefits = () => {
  const benefits = [
    {
      icon: FileText,
      title: 'Convert Existing Enablement Content',
      points: [
        'Vendor decks, SOPs, documentation, and certifications become structured training paths',
        'No rebuilding. No content loss.',
        'Training stays current as products evolve'
      ]
    },
    {
      icon: Users,
      title: 'Standardize Partner Readiness at Scale',
      points: [
        'Consistent training across partners, tiers, and regions',
        'Role-based learning paths by function or maturity',
        'Clear visibility into who\'s ready—and who isn\'t'
      ]
    },
    {
      icon: Target,
      title: 'Replace Passive Certification with Active Proof',
      points: [
        'AI role-play simulates real customer, sales, and support scenarios',
        'Performance is scored, not assumed',
        'Readiness becomes a signal—not a checkbox'
      ]
    },
    {
      icon: Zap,
      title: 'Accelerate Time-to-Value',
      points: [
        'Faster partner ramp-up',
        'Reduced support and enablement burden',
        'Stronger vendor confidence and satisfaction'
      ]
    }
  ];

  return (
    <section className="py-16 sm:py-24 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 text-white">
            How Traain Helps
            <br />
            <span className="text-cyan-400">Technology & Cloud Marketplaces</span>
          </h2>
        </div>

        <div className="grid sm:grid-cols-2 gap-4 sm:gap-8">
          {benefits.map((benefit, index) => {
            const Icon = benefit.icon;
            return (
              <div
                key={index}
                className="p-5 sm:p-8 rounded-2xl sm:rounded-3xl bg-gradient-to-br from-gray-900/90 to-blue-900/30 border border-cyan-500/30 hover:border-cyan-400/60 transition-all duration-300"
              >
                <div className="flex items-start gap-3 sm:gap-4 mb-4 sm:mb-6">
                  <div className="w-10 h-10 sm:w-14 sm:h-14 bg-cyan-500/10 border border-cyan-500/30 rounded-lg sm:rounded-xl flex items-center justify-center flex-shrink-0">
                    <Icon className="w-5 h-5 sm:w-7 sm:h-7 text-cyan-400" />
                  </div>
                  <h3 className="text-lg sm:text-2xl font-bold text-white">{benefit.title}</h3>
                </div>
                <ul className="space-y-2 sm:space-y-3">
                  {benefit.points.map((point, idx) => (
                    <li key={idx} className="flex items-start gap-2 sm:gap-3">
                      <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 bg-cyan-400 rounded-full mt-2 flex-shrink-0" />
                      <span className="text-sm sm:text-base text-gray-300">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default TechnologyBenefits;
